import { Api } from '../providers/api';
import { AppVersion } from '@ionic-native/app-version';
import { BookingThankYouPage } from '../pages/bookings/my-bookings/create-booking/booking-thank-you/booking-thank-you';
import { BrowserModule } from '@angular/platform-browser';
import { CancelBookingPage } from '../pages/bookings/my-bookings/cancel-booking/cancel-booking';
import { ComponentsModule } from '../components/components.module';
import { CreateBookingPage } from '../pages/bookings/my-bookings/create-booking/create-booking';
import { DashboardPage } from '../pages/dashboard/dashboard';
import { Database } from '../providers/database';
import { DatePicker } from '@ionic-native/date-picker';
import { DatePickerMock } from '../providers/mock/date-picker-mock';
import { DepartureDetailsPage } from '../pages/bookings/my-bookings/create-booking/departure-details/departure-details';
import { DerryBrothers } from './app.component';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { HttpModule } from '@angular/http';
import { IntroPage } from '../pages/intro/intro';
import { Keyboard } from '@ionic-native/keyboard';
import { LoginPage } from '../pages/auth/login/login';
import { MomentModule } from 'ngx-moment';
import { MyBookingsPage } from '../pages/bookings/my-bookings/my-bookings';
import { PlaceBookingPage } from '../pages/bookings/my-bookings/create-booking/place-booking/place-booking';
import { RegisterPage } from '../pages/auth/register/register';
import { RegisterThankYouPage } from '../pages/auth/register/thank-you/thank-you';
import { RouteDestinationListPage } from '../pages/route-destination-list/route-destination-list';
import { RouteInformationPage } from '../pages/route-information/route-information';
import { RoutePage } from '../pages/bookings/my-bookings/create-booking/route/route';
import { SamplePage } from '../pages/sample/sample';
import { SearchPage } from '../pages/search/search';
import { Shared } from '../providers/shared';
import { SpinnerDialog } from '@ionic-native/spinner-dialog';
import { SpinnerDialogMock } from '../../test-config/mocks/spinner-dialog-mock';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { SettingsPage } from '../pages/settings/settings';
import { ViewBookingPage } from '../pages/bookings/my-bookings/view-booking/view-booking';
import { ScreenOrientation } from '@ionic-native/screen-orientation';

export function createSpinnerDialog() {
    let instanceClass = typeof (<any> window).cordova !== 'undefined' ? SpinnerDialog : SpinnerDialogMock;
    return new instanceClass();
}

export function createDatePicker() {
    let instanceClass = typeof (<any> window).cordova !== 'undefined' ? DatePicker : DatePickerMock;
    return new instanceClass();
}

@NgModule({
    declarations: [
        BookingThankYouPage,
        CancelBookingPage,
        CreateBookingPage,
        DashboardPage,
        DepartureDetailsPage,
        DerryBrothers,
        IntroPage,
        LoginPage,
        MyBookingsPage,
        PlaceBookingPage,
        RegisterPage,
        RegisterThankYouPage,
        RouteDestinationListPage,
        RouteInformationPage,
        RoutePage,
        SamplePage,
        SearchPage,
        SettingsPage,
        ViewBookingPage,
    ],
    imports: [
        BrowserModule,
        ComponentsModule,
        HttpModule,
        IonicModule.forRoot(DerryBrothers),
        MomentModule,
    ],
    bootstrap: [IonicApp],
    entryComponents: [
        BookingThankYouPage,
        CancelBookingPage,
        CreateBookingPage,
        DashboardPage,
        DepartureDetailsPage,
        DerryBrothers,
        IntroPage,
        LoginPage,
        MyBookingsPage,
        PlaceBookingPage,
        RegisterPage,
        RegisterThankYouPage,
        RouteDestinationListPage,
        RouteInformationPage,
        RoutePage,
        SamplePage,
        SearchPage,
        SettingsPage,
        ViewBookingPage,
    ],
    providers: [
        Api,
        AppVersion,
        Database,
        Keyboard,
        ScreenOrientation,
        Shared,
        StatusBar,
        SpinnerDialog,
        SplashScreen,
        { provide: DatePicker, useFactory: createDatePicker },
        { provide: ErrorHandler, useClass: IonicErrorHandler },
        { provide: SpinnerDialog, useFactory: createSpinnerDialog },
    ]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts